<template>
  <div class="plv-ia__lotterying__content">
    <div
      ref="winnersListEl"
      class="plv-ia__lottery__list__area"
      :class="{'plv-ia__lottery__list__area__noscroll': lotterying}"
      @scroll="listScroll"
    >
      <!-- 抽奖中 -->
      <div v-if="lotterying" class="plv-ia-lottery__animate">
        <div
          v-show="isAnimate"
          id="animateCanvas"
          style="width: 240px; height: 240px;"
          loops="0"
          clearsAfterStop="true"
        ></div>
        <p v-if="delayTimeSecord !== 0" class="plv-ia-lottery__animate__delay">
          倒计时：
          <span class="plv-ia-lottery__animate__delay__color">{{
            calcDelay.hour
          }}</span>时
          <span class="plv-ia-lottery__animate__delay__color">{{
            calcDelay.min
          }}</span>分
          <span class="plv-ia-lottery__animate__delay__color">{{
            calcDelay.secord
          }}</span>秒
        </p>
        <p v-else class="plv-ia-lottery__animate__delay">中奖结果已发送</p>
      </div>
      <!-- 抽奖结束 -->
      <div v-else>
        <!-- 有中奖者 -->
        <div class="plv-ia__lottery_tips">
          <ul class="plv-ia-lottery__winner__list">
            <li class="winner-list__head">
              {{ t('plvIA.lottery.winnersList') }}
            </li>
            <li
              v-for="(item, index) in newWinnerList"
              :key="index"
              :class="{ 'lottery-only-one-list': newWinnerList.length <= 3 }"
            >
              <span v-for="i in item" :key="i.viewerName">{{
                i.viewerName
              }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="plv-ia__lottery-btn-group plv-lotterty-result">
      <button
        :class="['plv-ia-lottery-btn', { 'plv-lotteried': lotterying }]"
        @click="updateLotteryStatus"
      >
        {{
          lotterying ? t('plvIA.lottery.end') : t('plvIA.lottery.closeLottery')
        }}
      </button>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import SVGA from 'svgaplayerweb';
import Locale from '@/mixins/locale';
export default {
  name: 'LotteryLotterying',
  mixins: [Locale],
  props: {
    winnerList: {
      type: Array,
      default: () => []
    },
    prize: {
      type: String,
      default: ''
    },
    lotterying: {
      type: Boolean,
      default: false
    },
    delayStatus: {
      type: Boolean,
      default: false
    },
    delayTimeSecord: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      // delineDate: '2021-05-12'
      newWinnerList: [],
      sendList: false,
      winnerStr: '',
      isBreakdown: false,
      isAnimate: false
    };
  },
  computed: {
    calcDelay() {
      const delayTimeSecord = Math.floor(this.delayTimeSecord);

      let hour = 0;
      let min = 0;
      let secord = 0;

      if (delayTimeSecord > 60) {
        // 是否大于零
        min = delayTimeSecord / 60; // 分钟
        secord = delayTimeSecord % 60; // 秒
        if (min > 60) {
          // 存在时
          hour = min / 60;
          min = min % 60;
        }
      } else if (delayTimeSecord > 0) {
        secord = delayTimeSecord;
      }
      return {
        hour: Math.floor(hour),
        min: Math.floor(min),
        secord: Math.floor(secord)
      };
    }
  },

  watch: {
    // 监听中奖名单
    winnerList(val) {
      if (val.length === 0) {
        this.newWinnerList = [];
        return;
      }
      this.newWinnerList = this.changeAry(val);
      this.winnerStr = val.reduce(
        (pre, next) => `${pre}${next.viewerName}\n`,
        ''
      );
    },
    // 实例化动画
    lotterying(val) {
      if (val) {
        this.isAnimate = true;
        this.$nextTick(() => {
          this.initAnimate();
        });
      } else {
        this.isAnimate = false;
      }
    }
  },
  mounted() {
    if (this.lotterying) {
      this.isAnimate = true;
      this.initAnimate();
    }
  },

  methods: {
    // 实例化svga动画
    initAnimate() {
      const player = new SVGA.Player('#animateCanvas');
      const parser = new SVGA.Parser('#animateCanvas'); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
      parser.load(require('./images/box-gif.svga'), function(videoItem) {
        player.loops = 0; // 设置循环播放次数是1
        player.setVideoItem(videoItem);
        player.startAnimation();
      });
    },
    updateLotteryStatus() {
      // 如果定时抽奖完成倒计时,需要二次清理抽奖状态
      if (this.isBreakdown) {
        this.$emit('delay-end-lottery');
        return;
      }
      // isBreakdown 记录抽奖是否取消过
      this.isBreakdown = false;
      if (this.lotterying) {
        const breakdown = this.delayTimeSecord > 0 && this.delayStatus;
        this.isBreakdown = breakdown;
        this.$emit('end-lottery', breakdown);
        return;
      }
      this.$emit('new-turn-lottery', 'start');
    },

    // 复制中奖名单
    copyWinnerStr() {
      const clipboard = new Clipboard('#copyWinners');
      clipboard.on('success', () => {
        this.$iaMessage.default(this.t('plvIA.common.copySuccessfullyTips'));
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.$iaMessage.default(this.t('plvIA.common.copyUnsuccessfullyTips'));
        clipboard.destroy();
      });
    },

    changeAry(ary = [], n = 3) {
      if (!ary.length === 0) return [];
      const len = ary.length;
      const lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
      const newAry = [];
      for (let i = 0; i < lineNum; i++) {
        const s = ary.slice(i * n, i * n + n);
        newAry.push(JSON.parse(JSON.stringify(s)));
      }
      return newAry;
    },

    // 滚动加载名单
    listScroll() {
      const target = this.$refs.winnersListEl;
      const onBottom =
        target.scrollHeight - target.clientHeight - target.scrollTop;
      if (onBottom < target.clientHeight) this.$emit('up-to-bottom');
    }
  }
};
</script>

<style lang="scss" scoped>
.plv-ia__lottery__list__area__noscroll {
  overflow: hidden;
}
.plv-ia__lottery__list__area {
  height: 350px;
  // overflow: auto;
  overflow-x: hidden;
}

.plv-ia__lottery_tips {
  margin-top: 24px;
  text-align: center;
  font-size: 14px;
  position: relative;
  padding: 0 16px;

  span {
    color: #ff5722;
  }

  button {
    position: absolute;
    top: 0;
    right: 30px;
    background: none;
    border: none;
    outline: none;
    color: #2196f3;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.9;
    }
  }
}

.plv-ia__lottery-btn-group {
  text-align: center;

  .plv-lotterying-btn {
    font-size: 16px;
  }

  .plv-lotteried {
    background: rgba(255, 87, 34, 1);
    color: #fff;
  }
}

.plv-ia-lottery__animate {
  width: 400px;
  height: 280px;
  margin: 0 auto 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  .plv-ia-lottery__animate__delay {
    font-size: 14px;
    &__color {
      color: #45acff;
      font-size: 24px;
    }
  }
}

.plv-ia__lottery-btn-ing {
  margin-top: 10px;
  text-align: center;
}

.plv-ia-no__winner__tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > i {
    width: 60px;
    height: 60px;
    margin-top: 64px;
    background: url(./images/nowinner-icon.png) no-repeat;
    background-size: cover;
  }

  > p {
    margin-top: 8px;
    color: #757575;
    font-size: 12px;
  }

  .plv-lottery__tp {
    margin-top: 20px;
    font-size: 14px;
    color: #333;
  }

  .plv-ia-lottery-btn {
    margin-top: 24px;
  }
}
.plv-ia-lottery__winner__list {
  margin: 20px auto 0;

  .winner-list__head {
    height: 48px;
    background-color: #edf1f7;
    line-height: 48px;
    justify-content: center;
  }

  > li {
    height: 48px;
    line-height: 48px;
    display: flex;
    text-align: center;
    background-color: #f8f8fb;

    > span {
      color: #546e7a;
      width: 124px;
      margin: 0 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .lottery-only-one-list {
    border-bottom: 1px solid #eceff1;
  }

  li:nth-child(even) {
    background-color: #fff;
  }
}

.plv-lotterty-result {
  width: 100%;
  bottom: 0;
  margin: 0;
  text-align: center;
  padding: 24px 0 16px;
}
</style>
